<template>
    <div class="error">
        错误
        <button @click='btn()'>返回</button>
        <a href="javascript:history.back(-1)">返回</a>
    </div>
</template>

<script>
export default {
    data () {
        return {

        }
    },
    methods: {
        btn() {
            this.$router.go(-1);
        }
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/error/404.vue